export enum DeviceCategoryEnum {
    WEB = "Web",
    MOBILE = "Mobile",
    BOTH = "Both"
}